import { createUseStyles } from "react-jss";

export const RequiredFieldMessageStyle = createUseStyles((theme: any) => ({
    container: {
        display: "flex",
        alignItems: "center",
        gap: theme.gaps.sizes.xs,
    },
}));
